import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SiteReferenceService} from "./site-reference.service";
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class DevService {

  inMemory = {};

  constructor(private http: HttpClient, private siteReference: SiteReferenceService) {
  }

  public getMetadata() {
    return this.http.get('/gliders/api/metadata_comparison').toPromise();
  }
}
